// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { CorrelationVector } from './correlationVector';

let currentCV = CorrelationVector.createCorrelationVector();

// Values are made lowerCase before returned to caller because the headers are ultimately lowercase
export default {
    getPreviousCV: (): string => {
        // Returns previousValue for debugging (e.g. app insight operationId override) purposes
        return currentCV.previousValue.toLowerCase();
    },

    getCV: (): string => {
        // Returns current value and updates so next call will return next usable CV
        const cv = currentCV.value;
        currentCV.increment();
        return cv.toLowerCase();
    },

    getCurrentValue: (): string => {
        // Returns current value and updates so next call will return next usable CV
        return currentCV.value.toLowerCase();
    },

    resetCV: (): void => {
        currentCV = CorrelationVector.createCorrelationVector();
    },

    spinCV: (): void => {
        currentCV = CorrelationVector.spin(currentCV.value);
    },

    updateCV: (cv: string): void => {
        // Using the last used cv, parses value and updates the local value to the next usable CV
        currentCV = CorrelationVector.parse(cv);
        currentCV.increment();
    },
};
